export function backToTop(id) {
    let element = document.getElementById(id);
    let scrollPos = 0;

    let fadeOut = function (el) {
        el.style.opacity = 1;
        el.IsVisible = false;

        (function fade() {
            if ((el.style.opacity -= .1) < 0) {
                el.style.display = 'none';
            } else {
                requestAnimationFrame(fade);
            }
        })();
    };

    let fadeIn = function (el) {
        el.style.opacity = 0;
        el.style.display = 'flex';
        el.IsVisible = true;

        (function fade() {
            var val = parseFloat(el.style.opacity);
            if (!((val += .1) > 1)) {
                el.style.opacity = val;
                requestAnimationFrame(fade);
            }
        })();
    };

    let scrollTo = function (to, duration) {
        var doc = document.scrollingElement || document.documentElement;
        var start = doc.scrollTop;
        var change = to - start;
        var startDate = +new Date();

        var easeInOutQuad = function (time, start, change, duration) {
            time /= duration / 2;
            if (time < 1)
                return change / 2 * time * time + start;

            time--;

            return -change / 2 * (time * (time - 2) - 1) + start;
        };

        var animateScroll = function () {
            var currentDate = +new Date();
            var currentTime = currentDate - startDate;

            doc.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
            if (currentTime < duration) {
                requestAnimationFrame(animateScroll);
            } else {
                doc.scrollTop = to;
            }
        };
        animateScroll();
    };

    let trackScroll = function () {
        if (window.pageYOffset <= 50 && element.IsVisible) {
            fadeOut(element);
        } else {
            if ((document.body.getBoundingClientRect()).top > scrollPos && window.pageYOffset > 50 && !element.IsVisible)
                fadeIn(element);

            if ((document.body.getBoundingClientRect()).top < scrollPos && element.IsVisible)
                fadeOut(element);
        }

        scrollPos = (document.body.getBoundingClientRect()).top;
    }

    let backToTop = function () {
        scrollTo(0, 1000);
    }

    window.addEventListener('scroll', trackScroll, false);
    element.addEventListener('click', backToTop, false);

    trackScroll();
}


document.addEventListener('DOMContentLoaded', () => {

    if (document.getElementById('back-to-top')) {
        const id = 'back-to-top';
        backToTop(id);
    }
});